import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-lg font-heading text-background-50 block mb-3">91吃瓜爆料</span>
            <p className="text-sm text-secondary-300 leading-relaxed mb-4">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-secondary-800 flex items-center justify-center text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-tiktok-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <span className="text-sm font-semibold text-background-50 block mb-4">快速链接</span>
            <div className="space-y-2">
              {footerData.links.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="block text-sm text-secondary-300 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <span className="text-sm font-semibold text-background-50 block mb-4">合作伙伴</span>
            <div className="space-y-2">
              <span className="block text-sm text-secondary-400">—— 虚位以待 ——</span>
              <span className="block text-sm text-secondary-400">—— 虚位以待 ——</span>
              <span className="block text-sm text-secondary-400">—— 虚位以待 ——</span>
            </div>
          </div>

          <div>
            <span className="text-sm font-semibold text-background-50 block mb-4">友情链接</span>
            <div className="space-y-2">
              <span className="block text-sm text-secondary-400">—— 虚位以待 ——</span>
              <span className="block text-sm text-secondary-400">—— 虚位以待 ——</span>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-secondary-800">
          <p className="text-xs text-secondary-400 text-center">
            {footerData.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}